import { useAuth } from '@ahm/react-auth/auth-provider';
import { Box, Button, rem, Stack, Text } from '@mantine/core';
import { ArrowRight } from 'lucide-react';
import React, { useMemo } from 'react';
import { SPECIAL_TAGS } from '@/lib/constants';

function EntranceToRO() {
  const { session } = useAuth();
  const user = session?.user;
  const isRoSme = useMemo(() => {
    return user?.tags?.includes(SPECIAL_TAGS.SME_RO);
  }, [user]);

  const handleToRO = () => {
    const roV3Url = '/v3/ro-tool';
    const roSmeUrl = '/v3/ro';

    if (isRoSme) {
      window.open(roSmeUrl, '_blank');
    } else {
      window.open(roV3Url, '_blank');
    }
  };

  return (
    <Stack
      px={rem(16)}
      py={rem(12)}
      gap={rem(8)}
      bg="white"
      miw={rem(375)}
      style={{
        borderRadius: rem(8),
      }}
    >
      <Text size="sm" fw={500} c="neutral.6">
        Tạo đơn hàng loạt thật nhanh chóng, giúp tối ưu chi phí và thời gian với
        tính năng{' '}
        <Box component="span" fw={700}>
          "ĐA ĐƠN - ĐA ĐIỂM"
        </Box>
      </Text>
      <Button
        variant="transparent"
        rightSection={<ArrowRight size={16} />}
        onClick={handleToRO}
        fs={rem(14)}
        fw={700}
        lh={rem(20)}
        styles={{
          root: {
            padding: 0,
          },
          inner: {
            justifyContent: 'flex-start',
          },
        }}
      >
        Sử dụng ngay
      </Button>
    </Stack>
  );
}

export default EntranceToRO;
